const COUNTRY_CITIES = {
  "Türkiye": [
    "Adana","Adıyaman","Afyonkarahisar","Ağrı","Aksaray","Amasya","Ankara","Antalya","Ardahan","Artvin",
    "Aydın","Balıkesir","Bartın","Batman","Bayburt","Bilecik","Bingöl","Bitlis","Bolu","Burdur",
    "Bursa","Çanakkale","Çankırı","Çorum","Denizli","Diyarbakır","Düzce","Edirne","Elazığ","Erzincan",
    "Erzurum","Eskişehir","Gaziantep","Giresun","Gümüşhane","Hakkari","Hatay","Iğdır","Isparta","İstanbul",
    "İzmir","Kahramanmaraş","Karabük","Karaman","Kars","Kastamonu","Kayseri","Kırıkkale","Kırklareli","Kırşehir",
    "Kilis","Kocaeli","Konya","Kütahya","Malatya","Manisa","Mardin","Mersin","Muğla","Muş",
    "Nevşehir","Niğde","Ordu","Osmaniye","Rize","Sakarya","Samsun","Şanlıurfa","Siirt","Sinop",
    "Sivas","Şırnak","Tekirdağ","Tokat","Trabzon","Tunceli","Uşak","Van","Yalova","Yozgat","Zonguldak"
  ],
  "Almanya": [
    "Berlin","Hamburg","Munih","Köln","Frankfurt","Stuttgart","Düsseldorf","Dortmund","Essen","Leipzig",
    "Bremen","Dresden","Hannover","Nürnberg","Duisburg","Bochum","Wuppertal","Bielefeld","Bonn","Mannheim",
    "Karlsruhe","Augsburg","Wiesbaden","Münster","Gelsenkirchen","Aachen","Mönchengladbach","Braunschweig",
    "Kiel","Chemnitz","Freiburg","Halle","Magdeburg","Krefeld","Mainz","Lübeck","Erfurt","Rostock",
    "Oberhausen","Kassel","Hagen","Potsdam","Saarbrücken","Hamm","Ludwigshafen","Oldenburg","Osnabrück",
    "Leverkusen","Heidelberg","Darmstadt","Solingen","Regensburg","Herne","Paderborn","Neuss","Ingolstadt",
    "Offenbach","Würzburg","Ulm","Heilbronn","Pforzheim","Wolfsburg","Göttingen","Reutlingen","Koblenz",
    "Bremerhaven","Erlangen","Trier","Jena","Salzgitter","Cottbus","Moers"
  ],
  "Amerika Birleşik Devletleri": [
    "New York","Los Angeles","Chicago","Houston","Phoenix","Philadelphia","San Antonio","San Diego",
    "Dallas","San Jose","Austin","Jacksonville","Fort Worth","Columbus","Charlotte","Indianapolis",
    "San Francisco","Seattle","Denver","Washington DC","Nashville","Oklahoma City","El Paso","Boston",
    "Portland","Las Vegas","Memphis","Louisville","Baltimore","Milwaukee","Albuquerque","Tucson",
    "Fresno","Sacramento","Mesa","Kansas City","Atlanta","Omaha","Colorado Springs","Raleigh",
    "Long Beach","Virginia Beach","Miami","Oakland","Minneapolis","Tampa","Tulsa","Arlington",
    "New Orleans","Cleveland","Honolulu","Detroit","Salt Lake City","Pittsburgh","Orlando"
  ],
  "Avusturya": [
    "Viyana","Graz","Linz","Salzburg","Innsbruck","Klagenfurt","Villach","Wels","St. Pölten",
    "Dornbirn","Wiener Neustadt","Steyr","Feldkirch","Bregenz","Leonding","Baden","Wolfsberg",
    "Leoben","Traun","Krems","Amstetten","Lustenau","Kapfenberg","Hallein","Braunau","Mödling",
    "Kufstein","Schwechat","Traiskirchen","Hard","Spittal","Saalfelden","Ansfelden","Stockerau"
  ],
  "Azerbaycan": [
    "Bakü","Gence","Sumgayit","Mingeçevir","Lenkeran","Şirvan","Nahçivan","Şeki","Yevlah",
    "Hankendi","Berde","Haciqabul","Şamahi","Salyan","Agdaş","Kürdamir","Sabirabad","Saatli",
    "Agcabedi","Beylagan","Bilasuvar","Celilabad","Imişli","Göyçay","Zerdab","Ucar","Ağstafa",
    "Tovuz","Qazah","Balakan","Zakatala","Şamkir","Göygöl","Daşkasan"
  ],
  "Belçika": [
    "Brüksel","Antwerp","Gent","Charleroi","Liège","Brugge","Namur","Leuven","Mons","Mechelen",
    "Aalst","La Louvière","Hasselt","Sint-Niklaas","Kortrijk","Tournai","Genk","Oostende","Seraing",
    "Roeselare","Mouscron","Dendermonde","Beringen","Turnhout","Lokeren","Herstal","Châtelet",
    "Beveren","Waregem","Aarschot","Binche","Ieper"
  ],
  "Birleşik Krallık": [
    "Londra","Birmingham","Manchester","Glasgow","Liverpool","Leeds","Sheffield","Edinburgh",
    "Bristol","Leicester","Coventry","Bradford","Cardiff","Belfast","Nottingham","Kingston upon Hull",
    "Newcastle","Stoke-on-Trent","Southampton","Derby","Portsmouth","Brighton","Plymouth","Wolverhampton",
    "Sunderland","Reading","Luton","Aberdeen","Swansea","Bournemouth","Oxford","Cambridge","York",
    "Exeter","Bath","Canterbury","Dundee","Inverness","Northampton","Norwich"
  ],
  "Bulgaristan": [
    "Sofya","Plovdiv","Varna","Burgaz","Rusçuk","Stara Zagora","Pleven","Sliven","Dobriç","Şumen",
    "Pernik","Haskovo","Yambol","Pazarcık","Blagoevgrad","Veliko Tırnovo","Vratsa","Gabrovo",
    "Vidin","Kırcaali","Razgrad","Kyustendil","Montana","Silistre","Loveç","Tırgovişte","Sviştov"
  ],
  "Fransa": [
    "Paris","Marsilya","Lyon","Toulouse","Nice","Nantes","Strasbourg","Montpellier","Bordeaux","Lille",
    "Rennes","Reims","Saint-Étienne","Le Havre","Toulon","Grenoble","Dijon","Angers","Nîmes","Villeurbanne",
    "Clermont-Ferrand","Le Mans","Aix-en-Provence","Brest","Tours","Amiens","Limoges","Perpignan",
    "Metz","Besançon","Orléans","Rouen","Mulhouse","Caen","Nancy","Avignon","Cannes"
  ],
  "Hollanda": [
    "Amsterdam","Rotterdam","Lahey","Utrecht","Eindhoven","Groningen","Tilburg","Almere","Breda",
    "Nijmegen","Arnhem","Haarlem","Enschede","Amersfoort","Zaanstad","Apeldoorn","Hertogenbosch",
    "Zwolle","Maastricht","Leiden","Dordrecht","Haarlemmermeer","Zoetermeer","Emmen","Ede",
    "Delft","Deventer","Leeuwarden","Alkmaar","Venlo","Hilversum","Heerlen","Roosendaal"
  ],
  "İsveç": [
    "Stockholm","Göteborg","Malmö","Uppsala","Linköping","Örebro","Västerås","Helsingborg","Norrköping",
    "Jönköping","Umeå","Lund","Borås","Sundsvall","Gävle","Eskilstuna","Halmstad","Växjö","Karlstad",
    "Trollhättan","Södertälje","Luleå","Kalmar","Falun","Skellefteå","Kristianstad","Östersund",
    "Karlskrona","Borlänge","Varberg","Nyköping","Visby","Kiruna"
  ],
  "İsviçre": [
    "Zürih","Cenevre","Basel","Bern","Lozan","Winterthur","Luzern","St. Gallen","Lugano","Biel",
    "Thun","Köniz","La Chaux-de-Fonds","Fribourg","Schaffhausen","Chur","Neuchâtel","Vernier",
    "Sion","Lancy","Emmen","Yverdon","Kriens","Rapperswil-Jona","Uster","Zug","Dübendorf",
    "Montreux","Davos","Interlaken","Aarau","Baden","Bellinzona"
  ],
  "İtalya": [
    "Roma","Milano","Napoli","Torino","Palermo","Cenova","Bolonya","Floransa","Catania","Bari",
    "Venedik","Verona","Messina","Padova","Trieste","Brescia","Taranto","Parma","Prato","Modena",
    "Reggio Calabria","Perugia","Livorno","Ravenna","Cagliari","Foggia","Rimini","Salerno",
    "Ferrara","Sassari","Siracusa","Pescara","Bergamo","Trento","Vicenza","Ancona","Pisa","Lecce"
  ],
  "Kanada": [
    "Toronto","Montreal","Vancouver","Calgary","Edmonton","Ottawa","Winnipeg","Quebec","Hamilton",
    "Kitchener","London","Victoria","Halifax","Oshawa","Windsor","Saskatoon","Regina","St. John's",
    "Barrie","Kelowna","Abbotsford","Sherbrooke","Kingston","Sudbury","Thunder Bay","Trois-Rivières",
    "Guelph","Moncton","Brantford","Fredericton","Peterborough","Nanaimo","Red Deer","Lethbridge",
    "Kamloops","Prince George","Charlottetown","Yellowknife","Whitehorse"
  ],
  "Kuzey Kibris": [
    "Lefkoşa","Girne","Gazimağusa","Güzelyurt","İskele","Lefke","Yeniboğaziçi","Alsancak",
    "Lapta","Değirmenlik","Akdoğan","Mehmetçik","Dipkarpaz","Geçitkale","Beyarmudu"
  ],
  "Norveç": [
    "Oslo","Bergen","Trondheim","Stavanger","Kristiansand","Drammen","Tromsø","Fredrikstad","Sandnes",
    "Sarpsborg","Skien","Bodø","Ålesund","Sandefjord","Tønsberg","Moss","Haugesund","Arendal",
    "Porsgrunn","Hamar","Larvik","Halden","Lillehammer","Molde","Harstad","Gjøvik","Narvik",
    "Steinkjer","Kongsberg","Hammerfest","Alta","Kirkenes"
  ],
  "Romanya": [
    "Bükreş","Cluj-Napoca","Timişoara","Iaşi","Constanta","Craiova","Braşov","Galaţi","Ploieşti",
    "Oradea","Brăila","Arad","Piteşti","Sibiu","Bacău","Târgu Mureş","Baia Mare","Buzău",
    "Botoşani","Satu Mare","Râmnicu Vâlcea","Suceava","Drobeta-Turnu Severin","Piatra Neamţ",
    "Târgovişte","Focşani","Bistriţa","Tulcea","Reşiţa","Slatina","Alba Iulia","Deva"
  ],
  "Rusya": [
    "Moskova","St. Petersburg","Novosibirsk","Yekaterinburg","Kazan","Nijni Novgorod","Çelyabinsk",
    "Samara","Omsk","Rostov-na-Donu","Ufa","Krasnoyarsk","Voronej","Perm","Volgograd","Krasnodar",
    "Saratov","Tyumen","Tolyatti","Izhevsk","Barnaul","Ulyanovsk","Irkutsk","Habarovsk","Vladivostok",
    "Yaroslavl","Mahachkala","Tomsk","Orenburg","Kemerovo","Novokuznetsk","Ryazan","Astrahan",
    "Naberejnye Chelny","Penza","Lipetsk","Tula","Kirov","Çeboksarı","Kaliningrad","Kursk","Soçi"
  ],
  "Yunanistan": [
    "Atina","Selanik","Patras","Larisa","Iraklio","Volos","Rodos","Ioannina","Hanya","Kavala",
    "Halkida","Komotini","Serres","Aleksandrupoli","Trikala","Lamia","Agrinio","Katerini","Kalamata",
    "Kerkira","Mytilini","Sakız","Drama","Veria","Kozani","Naxos","Giannitsa","Preveza","Kastoria"
  ]
};

export default COUNTRY_CITIES;
